
const fn = async () => {
  return 'updateFn'
}

export default fn
